import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty, isUndefined } from 'lodash';
import TabNavigation from './TabNavigation';
import './styles.scss';

export default function TabNavigations({ isBordered, tabs, activeTab, className, tabClassName, numbered, onClick }) {
  if (isEmpty(tabs)) {
    return null;
  }

  return (
    <div className={classnames('ewc-tabnavs', className, { 'ewc-tabnavs--bordered': isBordered })}>
      {tabs.map((item, i) => {
        const { label, name, disabled, path, to, params } = item;
        return (
          <TabNavigation
            active={isUndefined(activeTab) ? activeTab : activeTab === name}
            disabled={disabled}
            index={i}
            key={i}
            label={label}
            numbered={numbered}
            onClick={() => (item.onClick ? item.onClick() : onClick && onClick(name, i))}
            params={params}
            path={path}
            to={to}
            wrapperClassName={tabClassName}
          />
        );
      })}
    </div>
  );
}

TabNavigations.propTypes = {
  activeTab: PropTypes.string,
  className: PropTypes.string,
  isBordered: PropTypes.bool,
  numbered: PropTypes.bool,
  onClick: PropTypes.func,
  tabClassName: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      name: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      params: PropTypes.object,
      path: PropTypes.string,
      to: PropTypes.string,
    }),
  ).isRequired,
};
